import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import "./CreateRoleDialog.scss";

const RenameDialog = ({ open, onClose, role, onRename }: any) => {
    console.log(role);

    const formik = useFormik({
        initialValues: {
            roleName: "",
        },
        validationSchema: Yup.object({
            roleName: Yup.string()
                .required("Role name is required")
                .min(3, "Role name must be at least 3 characters")
                .max(25, "Role name must not exceed 25 characters")
                .matches(/^[a-zA-Z0-9]+$/, "Role name must contain only alphabets and numbers"),
        }),
        onSubmit: (values) => {
            onRename(role,values.roleName);
            formik.resetForm();
            onClose();
        },
    });

    return (
        <Dialog sx={{
            "& .MuiDialog-paper": {
                position: "absolute",
                top: "50%",
                left: "50%",
                width: "350px",
                height: "270px",
                transform: "translate(-50%, -50%)",
            },
        }}
            open={open} onClose={onClose} fullWidth>
            <DialogTitle className="dialog-title">Rename the Role?</DialogTitle>
            <DialogContent>
                <p className="dialog-content">Name the title of the role you would like to create</p>
                <form onSubmit={formik.handleSubmit}>
                    <TextField sx={{ marginTop: "40px" }}
                        label="Role Name"
                        fullWidth
                        name="roleName"
                        value={formik.values.roleName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.roleName && Boolean(formik.errors.roleName)}
                        helperText={formik.touched.roleName && formik.errors.roleName}
                        margin="normal"
                    />
                </form>
            </DialogContent>
            <DialogActions sx={{ display: "flex", gap: "10px", justifyContent: "center", marginBottom: "15px" }}>
                <Button
                    sx={{ width: "120px" }}
                    onClick={() => {
                        formik.resetForm();
                        onClose();
                    }}
                    variant="outlined">
                    Cancel
                </Button>
                <Button
                    sx={{ width: "120px" }}
                    variant="contained"
                    color="primary"
                    className={`btn btn-primary`}
                    type="submit"
                    onClick={() => formik.handleSubmit()}
                    disabled={!formik.isValid || formik.isSubmitting}>
                    Rename
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default RenameDialog;